import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
const StyledSvg = styled(Icon) `
  width: ${(props) => (props.size === 'small' ? '24px' : '48px')};
  height: ${(props) => (props.size === 'small' ? '24px' : '48px')};
`;
export const Svg = ({ size = 'large', additionalClasses, children }) => {
    const viewBox = size === 'small' ? '0 0 24 24' : '0 0 48 48';
    return (React.createElement(StyledSvg, { size: size, viewBox: viewBox, className: additionalClasses },
        React.createElement(React.Fragment, null, children)));
};
